import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { AWS_URL } from "../../Constant";
import { Link } from "react-router-dom";

const Expenses = () => {
  const [expenses, setExpenses] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;
  // ✅ Fetch Expenses
  const fetchExpenses = async () => {
    setLoading(true);
    setError(null);
    const jwtToken = Cookies.get("jwt_token");

    try {
      const response = await fetch(`${AWS_URL}/getExpenses`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      const newdata = await response.json();
      const data = newdata["Expenses"];if (response.ok) {
        setExpenses(data);
        setFiltered(data);
      } else {
        setError(data?.message || "Failed to fetch expenses ❌");
      }
    } catch (err) {
      setError("Something went wrong while fetching ❌");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Search Filter
  useEffect(() => {
    let result = [...expenses];

    // Search filter
    if (search.trim() !== "") {
      result = result.filter(
        (exp) =>
          exp.item.toLowerCase().includes(search.toLowerCase()) ||
          exp.description.toLowerCase().includes(search.toLowerCase())
      );
    }

    // Date filter
    if (fromDate) {
      result = result.filter((exp) => new Date(exp.date) >= new Date(fromDate));
    }
    if (toDate) {
      result = result.filter((exp) => new Date(exp.date) <= new Date(toDate));
    }

    setFiltered(result);
    setCurrentPage(1); // reset pagination on new filter
  }, [search, fromDate, toDate, expenses]);

  useEffect(() => {
    fetchExpenses();
  }, []);

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentExpenses = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  return (
    <>
      <div className="bg-slate-100 min-h-screen p-6">
        <div className="flex justify-end">
          <Link to={"/dashboard"}>
            <button className="bg-red-500 px-2 py-1 mb-2 rounded-lg text-white text-md shadow-md hover:opacity-90">
              Dashboard
            </button>
          </Link>
        </div>
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-3">
          <h1 className="text-xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-2 rounded-lg shadow">
            Expenses List
          </h1>
          <button
            onClick={fetchExpenses}
            className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 px-4 py-2 rounded-lg text-white shadow hover:opacity-90"
          >
            Refresh
          </button>
        </div>

        {/* Filters */}
        <div className="grid sm:grid-cols-3 gap-4 mb-6">
          <input
            type="text"
            placeholder="Search by item or description..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border px-4 py-2 rounded-lg w-full focus:ring-2 focus:ring-blue-400"
          />

          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="border px-4 py-2 rounded-lg w-full focus:ring-2 focus:ring-blue-400"
          />

          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="border px-4 py-2 rounded-lg w-full focus:ring-2 focus:ring-blue-400"
          />
        </div>

        {/* Loading */}
        {loading && (
          <p className="text-blue-500 font-medium">Loading expenses...</p>
        )}

        {/* Error */}
        {error && <p className="text-red-600 font-medium">{error}</p>}

        {/* Table */}
        {!loading && currentExpenses.length > 0 ? (
          <div className="overflow-x-auto ">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200 text-sm text-gray-700">
                  <th className="px-4 py-2 ">Date</th>
                  <th className="px-4 py-2">Item</th>
                  <th className="px-4 py-2">Amount</th>
                  <th className="px-4 py-2">Description</th>
                  <th className="px-4 py-2">Image</th>
                </tr>
              </thead>
              <tbody>
                {currentExpenses.map((exp, index) => (
                  <tr
                    key={exp._id || index}
                    className="border-b hover:bg-slate-50"
                  >
                    <td className="px-4 py-2">{exp.date}</td>
                    <td className="px-4 py-2 font-medium">{exp.item}</td>
                    <td className="px-4 py-2 text-green-600 font-semibold">
                      ₹ {exp.amount}
                    </td>
                    <td className="px-4 py-2">{exp.description}</td>
                    <td className="px-4 py-2">
                      {exp.image ? (
                        <img
                          // src={`http://localhost:5000${exp.image}`}
                          src={
                            exp.image &&
                            (exp.image.startsWith("http://") ||
                              exp.image.startsWith("https://"))
                              ? exp.image
                              : `http://localhost:5000${exp.image}`
                          }
                          alt="expense"
                          className="w-28 h-28 object-cover rounded-lg cursor-pointer"
                          onClick={() =>
                            setSelectedImage(
                              exp.image
                              // `http://localhost:5000${exp.image}`
                            )
                          }
                        />
                      ) : (
                        "No image"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          !loading && <p className="text-gray-600 mt-4">No expenses found.</p>
        )}

        {/* Pagination */}
        {filtered.length > itemsPerPage && (
          <div className="flex justify-center items-center gap-3 mt-6">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
              className={`px-3 py-1 rounded-md ${
                currentPage === 1
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              Prev
            </button>

            <span className="font-medium">
              Page {currentPage} of {totalPages}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
              className={`px-3 py-1 rounded-md ${
                currentPage === totalPages
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Large preview"
            className="max-w-3xl max-h-full rounded-lg shadow-lg"
          />
        </div>
      )}
    </>
  );
};

export default Expenses;
